<app-page-header title="Home" active_item="Depósito"></app-page-header>
<div class="loading-deposit" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<h5>Depósito via Pix</h5>
<div class="row">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">Dados do Pagamento</div>
      </div>
      <div class="card-body">
        <form [formGroup]="deposito">
          <div class="row">
            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtDocumentoFavorecido" class="form-label">Documento pagador <span class="text-danger">*</span></label>
                <input mask="CPF_CNPJ" [formControl]="deposito.controls.documento" class="form-control" [ngClass]="{'is-invalid state-invalid': deposito.controls.documento.invalid && isSubmitted}" type="text" name="documentoFavorecido" id="txtDocumentoFavorecido">
                <div class="invalid-feedback">{{documentFeedBack}}</div>
              </div>
            </div>
            <div class="col-xl-9 col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtNomeFavorecido" class="form-label">Nome pagador <span class="text-danger">*</span></label>
                <input class="form-control" [ngClass]="{'is-invalid state-invalid': deposito.controls.nome.invalid && isSubmitted}" [formControl]="deposito.controls.nome" type="text" name="nomeFavorecido" id="txtNomeFavorecido" [required]="true">
                <div class="invalid-feedback">{{nomeFeedBack}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorSolicitado" class="form-label">Valor <span class="text-danger">*</span></label>
                <input placeholder="R$ 0,00" [formControl]="deposito.controls.valor" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                       class="form-control" [ngClass]="{'is-invalid state-invalid': deposito.controls.valor.invalid && isSubmitted}" type="text" name="valorSolicitado"
                        id="txtValorSolicitado" (focusout)="valorChanged()">
                <div class="invalid-feedback">{{valorFeedBack}}</div>
              </div>
            </div>
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtTaxa" class="form-label">Taxa</label>
                <input prefix="R$ " [formControl]="deposito.controls.taxa" mask="separator.2" [leadZero]="true" decimalMarker="," thousandSeparator="." class="form-control" type="text" name="taxa" id="txtTaxa" [readonly]="true">
              </div>
            </div>
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label for="txtValorTotal" class="form-label">Valor total</label>
                <input prefix="R$ " [formControl]="deposito.controls.valorTotal" mask="separator.2" [leadZero]="true" decimalMarker="," thousandSeparator="." class="form-control" type="text" name="valorTotal" id="txtValorTotal" [readonly]="true">
              </div>
            </div>
            <div class="col-xl col-lg-6 col-sm-6">
              <button type="button" class="our-button btn btn-pill btn-primary" (click)="makeDeposit()"><i class="fe fe-arrow-down-right"></i>Depositar</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="pixGenerated">
  <div class="col-12">
    <div class="card sales-summary rounded-10 shadow">
      <div class="card-header">
        <div class="card-title mb-0">Informações de Pagamento</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-xl-3 col-lg-6 col-sm-6 text-center">
            <h5 class="text-center">QR Code</h5>
            <img [src]="qrCodeBase64" alt="Qr Code" />
          </div>
          <div class="col-xl-9 col-lg-6 col-sm-6 text-center">
            <h5 class="text-center">Pix copia e cola</h5>
            <textarea class="form-control" [ngModel]="pixCopiaECola" disabled></textarea>
            <button class="btn btn-primary" placement="top" ngbPopover="Copiado!" [cdkCopyToClipboard]="pixCopiaECola">Copiar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
